import { AgreeArea } from "@components/organisms";
import { Colors } from "@utils";
import React from "react";
import styled from "styled-components";

import { useNavigate } from "react-router";

import privacyCI from "@assets/images/ci_privacy.png";
import { Button } from "@components/atoms";
import { useAppDispatch, useAppSelector } from "@store";
import { setAgreed } from "@store/slices/userInfoSlice";

const TopArea = styled.div`
  padding: 25px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Divider = styled.div`
  height: 8px;
  background: ${Colors.gray3};
`;

const BottomArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 22px;
  padding-bottom: 0px;
  flex-grow: 1;
`;

function AgreementPage() {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const initialAgreed = useAppSelector((state) => state.userInfo.agreed);

  const [allAgreed, setAllAgreed] = React.useState<boolean>(initialAgreed);

  const gotoWriteInfo = () => {
    dispatch(setAgreed(true));
    navigate("/write_info");
  };

  return (
    <div className="flex flex-col py-[22px] min-h-full">
      <TopArea>
        <div
          className="text-[20px] font-[700] mb-[26px] text-center"
          style={{ color: Colors.primaryGreen }}
        >
          <span className="text-[24px]">건강성적</span> 궁금하시지 않으신가요?
        </div>
        <div
          className="text-[15px] font-[600] text-center mx-[30px] whitespace-pre-wrap mb-[13px]"
          style={{ color: Colors.darkGray }}
        >
          고객님의 건강검진 받으신 혈압, 피검사 등의 검진{"\n"}
          수치와 연령, 성별을 활용하여 건강성적을 분석하기{"\n"}위하여 필수
          개인정보 입력이 필요합니다.
        </div>
        <img src={privacyCI} className="w-[149px] h-[97px]" alt="" />
      </TopArea>
      <Divider />
      <BottomArea>
        <AgreeArea
          onValidityChanged={(allAgreed) => setAllAgreed(allAgreed)}
          initialValue={initialAgreed}
          style={{ marginBottom: 20 }}
        />
        <div className="grow" />
        <div
          className="text-[13px]/[15px] font-[600] mb-[11px] whitespace-pre-wrap text-center"
          style={{ color: Colors.gray1 }}
        >
          건강성적표는 개인정보보호법을 준수하며{"\n"}입력하신 개인정보는 서비스
          외 다른 용도로 사용되지 않습니다.
        </div>
        <Button
          disabled={!allAgreed}
          bgColor={Colors.primaryGreen}
          color={Colors.white}
          onClick={gotoWriteInfo}
        >
          확인
        </Button>
      </BottomArea>
    </div>
  );
}

export default AgreementPage;
